import React, { useCallback, useEffect, useState } from 'react'

// redux
import { connect } from "react-redux";

// icons
import { BiCheck } from "react-icons/bi";

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// API
import { getCustomerCities, getCustomerCountries, getCustomerStates } from 'utlis/Apis/Customers_API';

// react toastify
import { toast } from 'react-toastify';

// payment options
import OptionCreditCard from './PaymentOptions/OptionCreditCard';


function CheckoutStepThree(props) {
    // props
    const {
        currentOrderId,
        cartDetails,

        allowedToDisplay,

        allCheckoutDetails,
        setAllCheckoutDetails,

        completedcheckoutSteps,
        setCompletedCheckoutSteps,

        paymentMethod,

        userBillingAddress,

        checkoutCurrentStep
    } = props

    // consts
    const paymentMethodsImages = [
        "https://d2scn539ulxr09.cloudfront.net/static/2021-39522-g5a52cbcce58/icons/visa.svg",
        "https://d2scn539ulxr09.cloudfront.net/static/2021-39522-g5a52cbcce58/icons/mastercard.svg",
        "https://d2scn539ulxr09.cloudfront.net/static/2021-39522-g5a52cbcce58/icons/amex.svg",
        "https://d2scn539ulxr09.cloudfront.net/static/2021-39522-g5a52cbcce58/icons/discover.svg",
        "https://d2scn539ulxr09.cloudfront.net/static/2021-39522-g5a52cbcce58/icons/jcb.svg",
        "https://d2scn539ulxr09.cloudfront.net/static/2021-39522-g5a52cbcce58/icons/diners_club.svg",
        "https://d2scn539ulxr09.cloudfront.net/static/2021-39522-g5a52cbcce58/icons/union-pay.svg"
    ]
    const DEFAULT_COUNTRY_TEMP = "254"

    // states
    const [btnDisabled, setBtnDisabled] = useState(false)
    const [sectionLoading, setSectionLoading] = useState(false)

    const [selectedShippingMethodName, setSelectedShippingMethodName] = useState("Credit or debit card, Free")

    const [addressesModalVisibility, setAddressesModalVisibility] = useState(false)
    const [selectedAddressId, setSelectedAddressId] = useState("")
    const [currentAddress, setCurrentAddress] = useState(null)

    const [countries, setCountries] = useState([])
    const [states, setStates] = useState([])
    const [cities, setCities] = useState([])

    const [stripeToken, setStripeToken] = useState()
    const [addressToShow, setAddressToShow] = useState("")

    // extract city by id
    const extractCityById = cityId => {
        if (cityId) {
            if (!cities?.length) return;
            const city = cities.find(item => item.city_id === parseInt(cityId))

            return city?.city ?? ""
        }
    }

    // extract state by id
    const extractStateById = stateId => {
        if (stateId) {
            if (!states?.length) return;

            const state = states.find(item => item.region_id === parseInt(stateId))

            return state?.region ?? ""
        }
    }

    // extract country by id
    const extractCountryById = countryId => {
        if (countryId) {
            if (!countries?.length) return;

            const country = countries.find(item => item.country_id === parseInt(countryId))

            return country?.country ?? ""
        }
    }

    // initial form values
    const initialFormValues = {
        paymentMethod: "credit-card",

        billingAddressSameAsShippingAddress: true,

        companyName: '',
        country: DEFAULT_COUNTRY_TEMP,
        state: '',
        city: '',
        zipCode: '',
        firstName: '',
        lastName: '',
        address: '',
        address1: '',
        phone: '',
        isDefault: false
    }

    // handle form validations
    const formValidationSchema = Yup.object({
        paymentMethod: Yup.string().required('This field is required'),

        billingAddressSameAsShippingAddress: Yup.boolean().required('This field is required'),

        companyName: Yup.string(),
        country: Yup.string().when("billingAddressSameAsShippingAddress", {
            is: false,
            // then: Yup.string().required('This field is required')
            then: Yup.string(),
        }),
        state: Yup.string().when("billingAddressSameAsShippingAddress", {
            is: false,
            then: Yup.string().required('This field is required')
        }),
        city: Yup.string().when("billingAddressSameAsShippingAddress", {
            is: false,
            then: Yup.string().required('This field is required')
        }),
        zipCode: Yup.string().when("billingAddressSameAsShippingAddress", {
            is: false,
            then: Yup.string().required('This field is required')
        }),
        firstName: Yup.string().when("billingAddressSameAsShippingAddress", {
            is: false,
            then: Yup.string().required('This field is required')
        }),
        lastName: Yup.string().when("billingAddressSameAsShippingAddress", {
            is: false,
            then: Yup.string().required('This field is required')
        }),
        address: Yup.string().when("billingAddressSameAsShippingAddress", {
            is: false,
            then: Yup.string().required('This field is required')
        }),
        address1: Yup.string(),
        phone: Yup.string().when("billingAddressSameAsShippingAddress", {
            is: false,
            then: Yup.string()
                .min(10, "Invalid phone number")
                .max(12, "Invalid phone number")
                .required('This field is required')
        }),
        isDefault: Yup.boolean(),
    })

    // handle form submmision
    const onFormSubmit = values => {
        if (values) {
            if (!addressToShow) {
                const addressToShowView = `${values.address}, ${values.address1 ? values.address1 + "," : ""} ${extractCityById(values.city)}, ${extractStateById(values.state)}, ${values.zipCode}, ${extractCountryById(DEFAULT_COUNTRY_TEMP)}`

                setAddressToShow(addressToShowView) // setting address to show if the step is complete

                formik.setFieldValue("billingAddressSameAsShippingAddress", true) // setting billing address details
            } else {
                setAllCheckoutDetails({
                    ...allCheckoutDetails,
                    stripe_token: stripeToken,

                    billingAddressSameAsShippingAddress: values.billingAddressSameAsShippingAddress,
                    billingAddressDetails: {
                        shipping_first_name: values.firstName,
                        shipping_middle_name: "",
                        shipping_last_name: values.lastName,
                        shipping_company_name: values.companyName,
                        shipping_address: values.address,
                        shipping_address1: values.address1,
                        shipping_city: values.city,
                        // shipping_country: values.country,
                        shipping_country: DEFAULT_COUNTRY_TEMP,
                        shipping_state: values.state,
                        shipping_zipcode: values.zipCode,
                        shipping_mobile: values.phone,
                        shipping_fax: "",
                        is_default: values.isDefault ? "1" : "0",
                        address_id: selectedAddressId,
                    }
                })
            }

        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
        enableReinitialize: true
    })

    // shipping method change
    const handleShippingMethodChange = (ev, name) => {
        const inpVal = ev.target.value
        if (inpVal) {
            formik.setFieldValue("paymentMethod", inpVal)

            // setting method name to show
            setSelectedShippingMethodName(name)
        }
    }

    // when user wants to shipping method
    const handleChangeMethod = (ev) => {
        ev.preventDefault()
        const updatedSteps = completedcheckoutSteps.filter(item => item !== "step4")

        setCompletedCheckoutSteps(updatedSteps)
    }

    // get countries
    const getCountries = useCallback((callBack = () => { }) => {
        // enabling laoding
        setSectionLoading(true)

        getCustomerCountries().then(res => {
            // disabling laoding
            setSectionLoading(false)

            const resData = res.data

            if (resData?.success) {
                setCountries(resData.data)

                // callback
                callBack()
            }
            if (resData?.error) {
                console.log('Error occured while loading countries', res)
            }
        }).catch(err => {
            console.log("error in the getCustomerCountries api ", err);
        })
    }, [])

    // get states
    const getStates = (countryId, callBack = () => { }) => {
        // enabling laoding
        setSectionLoading(true)

        getCustomerStates(DEFAULT_COUNTRY_TEMP).then(res => {
            // disabling laoding
            setSectionLoading(false)

            const resData = res.data

            if (resData.success) {
                setStates(resData.data)

                formik.setFieldValue("city", "")

                // callback
                callBack()

                if (!resData?.data?.length) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the message
                    toast.info("No city found from the selected state", {
                        autoClose: 2500,
                    });
                }

            }
            if (resData.error) {
                console.log('Error occured while loading states', res)
            }
        }).catch(err => {
            console.log("error in the getCustomerStates api ", err);
        })
    }

    // get states
    const getCities = (regionId, callBack = () => { }) => {
        // enabling laoding
        setSectionLoading(true)

        getCustomerCities(regionId).then(res => {
            // disabling laoding
            setSectionLoading(false)

            const resData = res.data

            if (resData.success) {
                setCities(resData.data)

                // callback
                callBack()

                if (!resData?.data?.length) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the message
                    toast.info("No city found from the selected state", {
                        autoClose: 2500,
                    });
                }
            }
            if (resData.error) {
                console.log('Error occured while loading cities', res)
            }
        }).catch(err => {
            console.log("error in the getCustomerCities api ", err);
        })
    }

    // choose address
    const chooseAddress = addressItem => {
        if (addressItem && Object.keys(addressItem)?.length) { // if object exists
            formik.setFieldValue("billingAddressSameAsShippingAddress", false) // setting billing address details

            setCurrentAddress(addressItem) // setting current selected address

            setSelectedAddressId(addressItem.addressId) // setting current selected address id

            formik.setFieldValue("zipCode", addressItem.zipCode) // setting zipCode name
            formik.setFieldValue("firstName", addressItem.firstName) // setting firstName name
            formik.setFieldValue("lastName", addressItem.lastName) // setting lastName name
            formik.setFieldValue("address", addressItem.address) // setting address name
            formik.setFieldValue("address1", addressItem.address1) // setting address name
            formik.setFieldValue("phone", addressItem.phone) // setting phone name
            formik.setFieldValue("companyName", addressItem.companyName) // setting companyName name
            formik.setFieldValue("isDefault", (addressItem.isDefault === "0") ? false : true) // setting companyName name

            // formik.setFieldValue("country", addressItem.countryId) // setting country name
            formik.setFieldValue("country", DEFAULT_COUNTRY_TEMP) // setting country name
            getStates(DEFAULT_COUNTRY_TEMP, () => { // callback
                formik.setFieldValue("state", addressItem.stateId) // setting state name
                getCities(addressItem.stateId, () => { // callback
                    formik.setFieldValue("city", addressItem.cityId) // setting city name

                    formik.submitForm() // submits the form
                }) // getting city
            }) // getting state

        } else {
            // resetting the form
            formik.resetForm()

            formik.setFieldValue("billingAddressSameAsShippingAddress", false) // setting billing address details

            setSelectedAddressId("") // setting current selected address id
        }
    }

    // choosing shipping address
    const chooseShippingAddress = (ev) => {
        ev.preventDefault()
        const addressItem = allCheckoutDetails?.shippingAddressDetails
        if (addressItem && Object.keys(addressItem)?.length) { // if object exists
            formik.setFieldValue("billingAddressSameAsShippingAddress", false) // setting billing address details

            setCurrentAddress(addressItem) // setting current selected address

            setSelectedAddressId(addressItem.address_id) // setting current selected address id

            formik.setFieldValue("zipCode", addressItem.shipping_zipcode) // setting zipCode name
            formik.setFieldValue("firstName", addressItem.shipping_first_name) // setting firstName name
            formik.setFieldValue("lastName", addressItem.shipping_last_name) // setting lastName name
            formik.setFieldValue("address", addressItem.shipping_address) // setting address name
            formik.setFieldValue("address1", addressItem.shipping_address1) // setting address name
            formik.setFieldValue("phone", addressItem.shipping_mobile) // setting phone name
            formik.setFieldValue("companyName", addressItem.shipping_company_name) // setting companyName name
            formik.setFieldValue("isDefault", (addressItem.is_default === "0") ? false : true) // setting companyName name

            // formik.setFieldValue("country", addressItem.shipping_country) // setting country name
            formik.setFieldValue("country", DEFAULT_COUNTRY_TEMP) // setting country name
            getStates(DEFAULT_COUNTRY_TEMP, () => { // callback
                formik.setFieldValue("state", addressItem.shipping_state) // setting state name
                getCities(addressItem.shipping_state, () => { // callback
                    formik.setFieldValue("city", addressItem.shipping_city) // setting city name
                }) // getting city
            }) // getting state

        } else {
            // resetting the form
            formik.resetForm()

            setSelectedAddressId("") // setting current selected address id
        }
    }

    // getting countries
    // useEffect(() => {
    //     if (checkoutCurrentStep === "step3") {
    //         getCountries() // getting countries
    //     }
    // }, [getCountries, checkoutCurrentStep])

    // getting countries
    useEffect(() => {
        if (checkoutCurrentStep === "step3" && currentAddress === null) {
            getCountries(() => { // callback
                if (cartDetails && Object.keys(cartDetails)?.length) {
                    const mainAddress = {
                        zipCode: cartDetails.bill_zipcode,
                        firstName: cartDetails.bill_first_name,
                        lastName: cartDetails.bill_last_name,
                        address: cartDetails.bill_address,
                        address1: cartDetails.bill_address1,
                        phone: cartDetails.bill_mobile,
                        companyName: cartDetails.bill_company_name,
                        isDefault: cartDetails.bill_is_default ? 1 : 0,
                        stateId: cartDetails.bill_state,
                        cityId: cartDetails.bill_city,
                    }

                    // setting address details
                    chooseAddress(mainAddress)
                }
            })
        }
    }, [
        checkoutCurrentStep,
        currentAddress,
        getCountries,
        cartDetails
    ])

    // country change
    const handleCountryChange = (ev) => {
        const inpVal = ev.target.value
        if (inpVal) {
            getStates(inpVal)
        }
    }

    // state change
    const handleStateChange = (ev) => {
        const inpVal = ev.target.value
        if (inpVal) {
            getCities(inpVal)
        }
    }

    return (
        <React.Fragment>
            {
                allowedToDisplay ? (
                    <React.Fragment>
                        {
                            completedcheckoutSteps?.length && completedcheckoutSteps.find(item => item === "step4") ? (
                                <div className="after-header border-bottom pb-3 mb-3">
                                    <div className="ah-inner d-flex">
                                        <div className="check me-3 d-flex align-items-center justify-content-center">
                                            <BiCheck fontSize={23} color={"#333"} />
                                        </div>
                                        <div className="content media-body st-fs-15">
                                            <p className="head st-fw-600 mb-0">Payment information</p>
                                            <p className="info mb-0">
                                                <span className="st-fw-600">{paymentMethod}</span>
                                                <span className="ms-3 st-fs-14 cursor-pointer" onClick={handleChangeMethod}>Change Method</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <OptionCreditCard
                                    formik={formik}

                                    handleShippingMethodChange={(ev, type) => handleShippingMethodChange(ev, type)}

                                    paymentMethodsImages={paymentMethodsImages}

                                    handleCountryChange={handleCountryChange}
                                    handleStateChange={handleStateChange}

                                    countries={countries}
                                    states={states}
                                    cities={cities}

                                    allCheckoutDetails={allCheckoutDetails}

                                    btnDisabled={btnDisabled}
                                    sectionLoading={sectionLoading}

                                    stripeToken={stripeToken}
                                    setStripeToken={setStripeToken}

                                    chooseShippingAddress={chooseShippingAddress}

                                    addressToShow={addressToShow}
                                />
                            )

                        }
                    </React.Fragment>
                ) : null
            }

        </React.Fragment>
    )
}


const getDataFromStore = (state) => {
    return {
    };
};

export default connect(getDataFromStore, null)(CheckoutStepThree);